// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: linear-gradient(135deg, #2a1010 0%, #3D1818 100%);
  padding: 13px 40px;
  margin-top: auto;
}

.footer-container {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.footer-title {
  font-size: 1.4rem;
  color: #E8DCC0;
  margin: 0;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.footer-tagline {
  font-size: 0.72rem;
  color: rgba(232, 220, 192, 0.5);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin: 0;
}

.footer-contact {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
}

.footer-contact-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.footer-contact-label {
  font-size: 0.78rem;
  color: rgba(232, 220, 192, 0.5);
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0;
}

.footer-link {
  font-size: 1.1rem;
  color: #E8DCC0;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: #ffffff;
}

.footer-divider {
  width: 1px;
  height: 28px;
  background: rgba(232, 220, 192, 0.2);
}

.footer-social {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  transition: all 0.2s ease;
  opacity: 1;
}

.footer-social-link:hover {
  opacity: 1;
  transform: translateY(-2px);
}

.footer-social-instagram {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}

.footer-social-facebook {
  background: #4267B2;
}

.footer-social-icon {
  width: 28px;
  height: 28px;
}

@media (max-width: 768px) {
  .footer {
    padding: 10px 24px;
  }

  .footer-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
  }

  .footer-contact {
    gap: 20px;
  }

  .footer-divider {
    display: none;
  }

  .footer-contact-item {
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".footer {\n  background: linear-gradient(135deg, #2a1010 0%, #3D1818 100%);\n  padding: 13px 40px;\n  margin-top: auto;\n}\n\n.footer-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.footer-brand {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.footer-title {\n  font-size: 1.4rem;\n  color: #E8DCC0;\n  margin: 0;\n  font-weight: 700;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.footer-tagline {\n  font-size: 0.72rem;\n  color: rgba(232, 220, 192, 0.5);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  margin: 0;\n}\n\n.footer-contact {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  flex-wrap: wrap;\n}\n\n.footer-contact-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.footer-contact-label {\n  font-size: 0.78rem;\n  color: rgba(232, 220, 192, 0.5);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin: 0;\n}\n\n.footer-link {\n  font-size: 1.1rem;\n  color: #E8DCC0;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.footer-link:hover {\n  color: #ffffff;\n}\n\n.footer-divider {\n  width: 1px;\n  height: 28px;\n  background: rgba(232, 220, 192, 0.2);\n}\n\n.footer-social {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.footer-social-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n  transition: all 0.2s ease;\n  opacity: 1;\n}\n\n.footer-social-link:hover {\n  opacity: 1;\n  transform: translateY(-2px);\n}\n\n.footer-social-instagram {\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n}\n\n.footer-social-facebook {\n  background: #4267B2;\n}\n\n.footer-social-icon {\n  width: 28px;\n  height: 28px;\n}\n\n@media (max-width: 768px) {\n  .footer {\n    padding: 10px 24px;\n  }\n\n  .footer-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 16px;\n  }\n\n  .footer-contact {\n    gap: 20px;\n  }\n\n  .footer-divider {\n    display: none;\n  }\n\n  .footer-contact-item {\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
